<script>
    import dragula from 'dragula';
    import dragdrop from './common/dragdrop.vue';
    import editor from './template/editor.vue';
    import settings from './template/templateSettings.vue';
    import moment from "moment";
    import toaster from "../common/toaster";
    import {
        widgetSettingsAndPropertiesToQueryString,
        widgetSettingsAndPropertiesToStructure
    } from '../../../utils/widget';

    export default {
        components: {
            dragdrop,
            editor,
            settings
        },
        props: [
            'template_id',
            'template_name',
            'template_activities',
            'template_resolution',
            'template_current_id',
            'inline',
            'back_url',
            'insert_data',
            'taking_picture',
            'publish_privilege',
            'approve_privilege',
            'stretch'
        ],
        data: function () {
            return {
                t_endless_loop: Lang.langGet("Checking for endless loop. This may take a while."),
                t_endless_loop_fail: Lang.langGet("You are not allowed to add the element, an endless loop was detected:"),
                t_template_link_fail: Lang.langGet("Failed to link template!"),
                t_campaign_link_fail: Lang.langGet("Failed to link campaign!"),
                t_auto_approve: Lang.langGet("The modified content gets approved in all layers."),
                t_auto_keep_approved: Lang.langGet("Approved state of layer elements is not changed."),
                t_auto_disapprove: Lang.langGet("Layer elements that contain the modified content get disapproved."),
                t_auto_publish: Lang.langGet("Layers that contain the modified content get published to the relevant screens."),
                t_auto_not_publish: Lang.langGet("Layer elements do not get published."),
                active_element: {
                    usergroups: [],
                    layers: [],
                    tags: [],
                    index: null
                },
                saving: false,
                previewing: false,
                is_limited: false,
                creator: false,
                grid: '2cols',
                mode: '',
                layout: 'editor-right',
                startDragdropCollapsed: false,
                startSettingsCollapsed: false,
                startDragdropActive: false,
                startSettingsActive: false,
                inner_name: this.template_name,
                disabledZoomPlus: false,
                disabledZoomMinus: false,
                zoomOptions: [20,40,70,100,140,200,300,400,500],
                zoomIndex: 3,
                windowInfo: {},
                editorFrame: {},
                updatePublish: 0,
                updateApprove: -1,
                descriptionSelection: 0,
                creatorHeaderBlockSize: 56,
                creatorHeaderResizeObserverCloseHandle: () => null,
            }
        },
        computed: {
            creatorStyles: function () {
                let height = (Math.max(300, this.windowInfo.contentHeight ?? 692));

                return {
                    height: `${height}px`
                }
            },
            t_in_use: function () {
                return Lang.langGet("The current element is currently being edited by the following persons: :persons", {persons: _.join(JSON.parse(this.template_activities), ', ')});
            },
            portraitMode: function () {
                let resolution = this.template_resolution.split("x");
                return (resolution[0] / resolution[1] < 1)
            },
            zoom: function () {
                return this.zoomOptions[this.zoomIndex];
            },
            trueZoom: function () {
                return Math.round(this.editorFrame.ratio * 100) + '%';
            },
            editorStyles() {
                return {
                    '--display-description-always': this.descriptionSelection == 1 ? 'block' : undefined,
                    '--display-description-on-hover': this.descriptionSelection == 2 ? 'block' : undefined,
                    '--display-description-on-select': this.descriptionSelection == 3 ? 'block' : undefined
                }
            }
        },
        methods: {
            appendDragdropAndSettings: function () {
                if (this.grid === '2cols') {
                    document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('dragdrop-col'));
                    document.getElementById('dragdrop-settings-col').appendChild(document.getElementById('settings-col'));
                } else {
                    document.getElementById('creator-row').appendChild(document.getElementById('dragdrop-col'));
                    document.getElementById('creator-row').appendChild(document.getElementById('settings-col'));
                }
            },
            setupDragula: function (disableCanvas) {
                if (disableCanvas === true) {
                    this.is_limited = true;
                }

                let containers = [
                        document.querySelector('.dragdrop-content .mediapool-list'),
                        document.querySelector('.dragdrop-content .drag-element-list'),
                        document.querySelector('.dragdrop-content .widgets-list'),
                        document.querySelector('.dragdrop-content .template-list'),
                        document.querySelector('.dragdrop-content .campaign-list'),
                        document.querySelector('.replace-dropzone:not(.dropzone-readonly)'),
                        document.querySelector('.alternative-dropzone:not(.dropzone-readonly)'),
                        document.querySelector('.attach-dropzone:not(.dropzone-readonly)'),
                    ];

                if (this.is_limited !== true) {
                    containers.push(document.querySelector('#editor-canvas:not(.dropzone-readonly)'));
                }

                dragula(containers, {
                    isContainer: function (el) {
                        return false;
                    },
                    moves: function (el, source, handle, sibling) {
                        return source.id !== 'editor-canvas';
                    },
                    accepts: function (el, target, source, sibling) {
                        let elementType = $(el).find('.element-data').data('type'), dropzoneType = target.getAttribute('data-type');
                        let dropzoneTypes = [];
                        if(typeof dropzoneType === 'string') {
                            dropzoneTypes = target.getAttribute('data-type').split('|');
                        }
                        return target.id === 'editor-canvas' || (
                            (
                                target.classList.contains('replace-dropzone')
                                || target.classList.contains('alternative-dropzone')
                                || target.classList.contains('attach-dropzone')
                            ) && dropzoneTypes.includes(elementType)
                        );
                    },
                    direction: 'vertical',
                    copy: true,
                    mirrorContainer: document.body,
                }).on('drop', (el, target, source, sibling) => {
                    let dropping = true;

                    if (!target) {
                        return false;
                    } else {
                        EaseEventBus.fire('settingsActive');
                    }

                    let elementData = $(el).find('.element-data');

                    let type = elementData.data('type'),
                        id = elementData.data('file-id') || null,
                        name = elementData.data('display-name') || '',
                        state = 'unknown',
                        valid_from = elementData.data('valid-from') || '',
                        valid_to = elementData.data('valid-to') || '',
                        width = elementData.data('width') || 0,
                        height = elementData.data('height') || 0,
                        page_count = elementData.data('page-count') || 0,
                        dynamic = null;

                    // "catch" drops to attach List for (Web) Elements
                    if (target.classList.contains('attach-dropzone') ) {
                        const files = this.active_element.linked_files;
                        if (files.length === 0) {
                            this.active_element.linked_files = [{id: id, name: name}];
                        } else if (files.some((element) => element.id === id) === false) {
                            this.active_element.linked_files.push({id: id, name: name});
                        }
                        return;
                    }

                    if (_.indexOf(['campaign', 'template'], type) !== -1) {
                        state = 'link';
                    }

                    if (type === 'campaign') {
                        dynamic = elementData.data('campaign-dynamic') || false;
                    }

                    let url = '';
                    if (type === 'widget') {
                        url = elementData.data('thumbnail') || null;
                    } else {
                        url = elementData.data('preview-name') || null;
                    }

                    var targetBounding = $(target)[0].getBoundingClientRect();
                    var x = event.clientX - targetBounding.x;     // Get the horizontal coordinate
                    var y = event.clientY - targetBounding.y;     // Get the vertical coordinate
                    var position = {'left': x, 'top': y};

                    let structure = {
                        position: position,
                        size: {
                            width: width,
                            height: height
                        },
                        page_count: page_count,
                        type: type,
                        id: id,
                        background_image: url,
                        name: name,
                        state: state,
                        dynamic: dynamic,
                        valid_from: valid_from,
                        valid_to: valid_to
                    };

                    if (type == 'widget') {
                        structure = {
                            ...widgetSettingsAndPropertiesToStructure(elementData.data('settings')),
                            query_string: widgetSettingsAndPropertiesToQueryString(elementData.data('settings')),
                            ...structure
                        };
                    }

                    if (type === 'widget' && elementData.data('preview-name')) {
                        structure['index_html'] = elementData.data('preview-name');
                    }

                    if (['picture', 'video', 'pdf', 'ppt', 'template', 'campaign'].includes(type)) {
                        structure.valid_to = '';
                        structure.valid_from = '';
                        structure.valid_to_placeholder = valid_to;
                        structure.valid_from_placeholder = valid_from;
                    }

                    if(['picture', 'video', 'pdf', 'ppt'].includes(type)) {
                        structure.stretch = this.stretch;
                    }

                    if (type === 'template') {
                        let resolution = elementData.data('resolution').split('x');
                        let id = elementData.data('template-id') || null;
                        structure.size.width = resolution[0];
                        structure.size.height = resolution[1];

                        toaster.warning(this.t_endless_loop);
                        dropping = false;

                        axios.post('/endless-loop-content', {
                            project: Laravel.activeProject,
                            search_type: 'template',
                            search_id: this.template_id,
                            search_name: this.template_name,
                            start_type: 'template',
                            start_id: id,
                            start_name: name
                        }).then(() => {
                            toastr.clear();

                            axios.post('/content/template/link', {
                                project: Laravel.activeProject,
                                id: id
                            }).then((response) => {
                                id = response.data.data.id;
                                structure.id = id;
                                if (target.classList.contains('alternative-dropzone')) {
                                    EaseEventBus.fire('alternativeElementUpdate', {id: id, url: url, type: type, name: name});
                                } else {
                                    EaseEventBus.fire('addElementToCanvasDragDrop', structure);
                                }
                            }).catch(() => {
                                toaster.error(this.t_template_link_fail);
                            });
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                window.location = '/login';
                            }

                            let escapedPath = $("<div>").text(error.response.data.data.path).html();
                            toastr.clear();
                            toaster.error(this.t_endless_loop_fail + ' ' + escapedPath);
                        });
                    }

                    if (type === 'campaign') {
                        let resolution = elementData.data('resolution').split('x');
                        let id = elementData.data('campaign-id') || null;
                        structure.size.width = resolution[0];
                        structure.size.height = resolution[1];

                        toaster.warning(this.t_endless_loop);
                        dropping = false;

                        axios.post('/endless-loop-content', {
                            project: Laravel.activeProject,
                            search_type: 'template',
                            search_id: this.template_id,
                            search_name: this.template_name,
                            start_type: 'campaign',
                            start_id: id,
                            start_name: name
                        }).then(() => {
                            toastr.clear();

                            axios.post('/content/campaign/link', {
                                project: Laravel.activeProject,
                                id: id
                            }).then(function (response) {
                                id = response.data.data.id;
                                structure.id = id;
                                if (target.classList.contains('alternative-dropzone')) {
                                    EaseEventBus.fire('alternativeElementUpdate', {id: id, url: url, type: type, name: name});
                                } else {
                                    EaseEventBus.fire('addElementToCanvasDragDrop', structure);
                                }
                            }).catch(() => {
                                toastr.clear();
                                toaster.error(this.t_campaign_link_fail);
                            });
                        }).catch((error) => {
                            if (error.response.status === 401) {
                                window.location = '/login';
                            }

                            let escapedPath = $("<div>").text(error.response.data.data.path).html();
                            toastr.clear();
                            toaster.error(this.t_endless_loop_fail + ' ' + escapedPath);
                        });
                    }

                    if (target.id === 'editor-canvas' && dropping === true && type.indexOf('placeholder') === -1) {
                        EaseEventBus.fire('addElementToCanvasDragDrop', structure);
                    }

                    if (target.classList.contains('replace-dropzone')) {
                        EaseEventBus.fire('replaceElementInCanvas', structure);
                    }

                    if (target.classList.contains('alternative-dropzone') && dropping === true) {
                        EaseEventBus.fire('alternativeElementUpdate', {id: id, url: url, type: type, name: name});
                    }

                    if (type.indexOf('placeholder') !== -1) {
                        EaseEventBus.fire('updateTemplateAndAdd', {type: type, x: x, y: y});
                    }

                    el.remove();
                });
            },
            updateTemplate: function (approve=0, publish=0) {
                if (this.creator === true) {
                    if (this.saving !== true) {
                        EaseEventBus.fire('updateTemplate', {refresh: true, back: false, approve: approve, publish: publish});
                        this.saving = true;
                    }
                }
            },
            previewTemplate: function () {
                if(this.previewing === true) {
                    return;
                }

                EaseEventBus.fire('previewTemplate');
                this.previewing = true;
            },
            updateInlineTemplate: function (approve = 0, publish = 0) {
                if (!this.creator) return;
                if (this.saving) return;

                const data = {refresh: false, back: true, approve: approve, publish: publish};

                EaseEventBus.fire('updateTemplate', data);
                this.saving = true;
            },
            cancelInlineTemplate: function () {
                this.endActivity();
                window.location = this.back_url;
            },
            updateValidation: function (value) {
                this.creator = value;
            },
            triggerActivity: function () {
                axios.get('/activity/' + Laravel.activeUser + '/' + this.template_id + '/template')
                    .then(function () {
                    })
                    .catch(function () {
                    });
            },
            endActivity: function () {
                axios.get('/endactivity/' + Laravel.activeUser + '/' + this.template_id + '/template')
                    .then(function () {
                    })
                    .catch(function () {
                    });
            },
            setStartCollapse: function () {
                let settingsCollapsed = false;
                let dragdropCollapsed = false;
                let settingsActive = true;
                let dragdropActive = false;
                if (this.grid === '2cols') {
                    let savedSettingsCollapsed = localStorage.getItem('templatecreator-settings-collapsed-' + Laravel.activeProject);
                    let savedDragdropCollapsed = localStorage.getItem('templatecreator-dragdrop-collapsed-' + Laravel.activeProject);
                    if (savedSettingsCollapsed !== null && savedDragdropCollapsed !== null) {
                        settingsCollapsed = savedSettingsCollapsed === 'true';
                        dragdropCollapsed = savedDragdropCollapsed === 'true';
                    }

                    let savedSettingsActive = localStorage.getItem('templatecreator-settings-active-' + Laravel.activeProject);
                    if (savedSettingsActive === null) {
                        if (this.template_current_id === this.template_id) {
                            dragdropActive = true;
                            settingsActive = false;
                        }
                    } else {
                        settingsActive = savedSettingsActive === 'true';
                        dragdropActive = !settingsActive;
                    }
                }

                this.startSettingsCollapsed = settingsCollapsed;
                this.startDragdropCollapsed = dragdropCollapsed;
                this.startSettingsActive = settingsActive;
                this.startDragdropActive = dragdropActive;
            },
            title: function () {
                return this.inner_name;
            },
            zoomClick: function (plus) {
                if(plus) {
                    if (this.zoomIndex < this.zoomOptions.length - 1) {
                        this.zoomIndex++;
                        this.disabledZoomMinus = false;
                        if (this.zoomIndex == this.zoomOptions.length - 1) {
                            this.disabledZoomPlus = true;
                        }
                    } else {
                        this.disabledZoomPlus = true;
                    }
                } else {
                    if(this.zoomIndex > 0) {
                        this.zoomIndex--;
                        this.disabledZoomPlus = false;
                        if (this.zoomIndex == 0) {
                            this.disabledZoomMinus = true;
                        }
                    } else {
                        this.disabledZoomMinus = true;
                    }
                }
                EaseEventBus.fire('zoomEditorFrame', this.zoom / 100.0);
            },
            formatDateEnglish(value) {
                if(value) {
                    let savedFormat = 'MM/DD/yyyy';
                    if (value.includes('.')) {
                        savedFormat = 'DD.MM.yyyy';
                    }

                    let date = moment(value, savedFormat);
                    return date.isValid() ? date.format('MM/DD/yyyy') : '';
                } else {
                    return "";
                }
            },
            cycleUpdatePublish: function () {
                this.updatePublish = (parseInt(this.updatePublish) + 1) % 2 || 0;
                localStorage.setItem("templatecreator-" + (this.inline === 'true' ? 'inline-' : '') + "publish-" + Laravel.activeProject, this.updatePublish);
            },
            cycleUpdateApprove: function () {
                this.updateApprove = (parseInt(this.updateApprove) + 1) % 3 || 0;
                this.updateApprove = this.updateApprove === 2 ? -1 : this.updateApprove;
                localStorage.setItem("templatecreator-" + (this.inline === 'true' ? 'inline-' : '') + "approve-" + Laravel.activeProject, this.updateApprove);
            }
        },
        watch: {
            grid: function (val) {
                localStorage.setItem('templatecreator-grid-' + Laravel.activeProject, val);
                this.setStartCollapse();
                this.appendDragdropAndSettings();
            },
            descriptionSelection(val) {
                localStorage.setItem(`templatecreator-description.${Laravel.activeUser}.${Laravel.activeProject}`, val);
            }
        },
        created() {
            this.descriptionSelection = +(localStorage.getItem(`templatecreator-description.${Laravel.activeUser}.${Laravel.activeProject}`) ?? 0)
        },
        mounted() {
            if (this.publish_privilege && this.approve_privilege) {
                this.updatePublish = parseInt(localStorage.getItem("templatecreator-" + (this.inline === 'true' ? 'inline-' : '') + "publish-" + Laravel.activeProject) ?? 1);
            }
            if (this.approve_privilege) {
                this.updateApprove = parseInt(localStorage.getItem("templatecreator-" + (this.inline === 'true' ? 'inline-' : '') + "approve-" + Laravel.activeProject) ?? 1);
            }

            let insertData = null;

            if (this.insert_data !== undefined) {
                insertData = JSON.parse(this.insert_data);
              this.setupDragula();
            }

            const localStorageLayoutKey = `templatecreator-layout-${Laravel.activeProject}`;
            const layout = localStorage.getItem(localStorageLayoutKey);
            this.layout = layout ? layout : 'editor-right';

            EaseEventBus.listen(localStorageLayoutKey, (val) => this.layout = val);

            let grid = localStorage.getItem('templatecreator-grid-' + Laravel.activeProject);

            if (grid !== null) {
                this.grid = grid;
            } else {
                let width = 0, height = 0;
                let resolution = this.template_resolution.split('x');
                width = resolution[0];
                height = resolution[1];
                if (width >= height) {
                    this.grid = '2cols';
                } else {
                    this.grid = '3cols';
                }
            }
            this.setStartCollapse();
            this.appendDragdropAndSettings();

            if (_.size(insertData) > 0) {
                let structure = {
                    position: {'left': insertData.x, 'top': insertData.y},
                    size: {
                        width: insertData.width,
                        height: insertData.height
                    },
                    type: insertData.type,
                    id: insertData.id,
                    background_image: insertData.picture,
                    name: insertData.name
                };

                switch (insertData.type) {
                    case 'picture':
                    case 'video':
                    case 'pdf':
                    case 'ppt':
                        structure.state = 'unknown';
                        break;
                }

                if (insertData.x !== '-1' && insertData.y !== '-1') {
                    EaseEventBus.fire('addElementToCanvasDragDrop', structure);
                }
            }

            EaseEventBus.listen('reinitializeDragula', (disableCanvas) => {
              this.setupDragula(disableCanvas);
            });

            EaseEventBus.listen('doneUpdatingTemplate', () => {
              this.saving = false;
            });

            EaseEventBus.listen('donePreviewing', () => {
              this.previewing = false;
            });

            EaseEventBus.listen('templateNameUpdated', (new_name) => {
              this.inner_name = new_name;
            });

            EaseEventBus.listen('settingsCollapsed', (collapsed) => {
                localStorage.setItem('templatecreator-settings-collapsed-' + Laravel.activeProject, collapsed);
            });

            EaseEventBus.listen('dragdropCollapsed', (collapsed) => {
                localStorage.setItem('templatecreator-dragdrop-collapsed-' + Laravel.activeProject, collapsed);
            });

            EaseEventBus.listen('settingsActive', () => {
                localStorage.setItem('templatecreator-settings-active-' + Laravel.activeProject, true);
            });

            EaseEventBus.listen('dragdropActive', () => {
                localStorage.setItem('templatecreator-settings-active-' + Laravel.activeProject, false);
            });

            EaseEventBus.listen('windowInfo', (data) => {
                this.windowInfo = _.extend({}, this.windowInfo, data);
            });

            EaseEventBus.listen('frameInfos', (data) => {
              this.editorFrame = _.extend({}, this.editorFrame, data);
            });

            if (this.inline === 'true') {
                $(this.$el).find('.actions').appendTo('#inline-actionbuttons');
            }

            let templateActivities = JSON.parse(this.template_activities);

            if (_.size(templateActivities) > 0 && !this.taking_picture) {
                toaster.warning(this.t_in_use);
            }

            this.triggerActivity();
            setInterval(() => {
              this.triggerActivity();
            }, 45000);

            window.addEventListener('unload', (e) => {
                this.endActivity();
            });

            const creatorHeaderResizeObserver = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    const contentBoxSize = entry.borderBoxSize[0]
                    this.creatorHeaderBlockSize = contentBoxSize.blockSize
                }
            })

            creatorHeaderResizeObserver.observe(this.$refs.creatorHeader)
            this.creatorHeaderResizeObserverCloseHandle = creatorHeaderResizeObserver.unobserve
        },
        beforeDestroy() {
            this.creatorHeaderResizeObserverCloseHandle?.()
        }
    }
</script>
